import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { PosPlugin } from 'plugins/plugin';

import { getIsAllowed } from '../configuration/Configuration';

const OriginalPayment: PosPlugin['UIOriginalPayment'] = ({
  payment,
  onClick,
  children,
}) => {
  const isAllowed = useSelector(getIsAllowed);
  const isGivexPayment = payment.paymentIntegration === 'givex';

  return React.Children.map<ReactNode, ReactNode>(children, child => {
    if (!React.isValidElement(child)) return child;

    const disabled = isGivexPayment ? !isAllowed : child.props.disabled;
    return React.cloneElement(child, {
      disabled,
      onClick: !disabled ? onClick : undefined,
      style: { cursor: disabled ? 'not-allowed' : 'pointer' },
    });
  });
};

export default OriginalPayment;
